import styles from './table.module.scss';
import {ReactElement} from 'react';
import {classNames} from '../../support/classnames.ts';

interface OwnProps {
    name: string | ReactElement;
    value?: number | string | null | ReactElement;
    secondaryValue?: number | string | null | ReactElement;
    url?: string | null;
}

export function TableCell({name, value, secondaryValue, url}: OwnProps) {
    return (
        <div
            className={classNames(styles.table__cell, {
                [styles.secondary_value]: secondaryValue != null,
            })}
        >
            <strong>{name}</strong>
            {url ? (
                <span>
                    <a href={url}>{value ?? ''}</a>
                </span>
            ) : (
                <span>{value ?? ''}</span>
            )}
            {secondaryValue && <span>{secondaryValue}</span>}
        </div>
    );
}
